import React from 'react';
import './Machinefeartu.css';

const Machinefeartu = () => {
    return (
        <div className="Machinefear-container">

            <div className="Machinefear-text">
                <h2>Machine Feartures</h2>
                <ul>
                    <li>Blow Molding In One Stage, Increase Productivity & Saving Labor Costs.</li>
                    <li>Can Be Converted Into A Normal Machine With Changing Machine Parts.</li>
                    <li>High Out Put With Small Machine. A60 Housing For 12 Cavity A80 Housing For 8 Cavity.</li>
                    <li>Max Diameter Of The LED Housing Can Be Reach 135mm With 2 Cavity Mold By IBM200S6-R.</li>
                </ul>
            </div>
        </div>
    );
};

export default Machinefeartu;

